<template>
  <div
    class="flex items-center font-body text-sm gap-2 w-full h-14"
    :class="{ 'opacity-30 pointer-events-none': disabled }"
  >
    <div
      v-for="option in options"
      :key="option.id"
      ref="optionsRef"
      class="rounded-lg px-4 flex flex-row items-center border transition-colors dark:text-n-0 text-n-800 cursor-pointer w-full h-full justify-center"
      :class="[
        option.id === model
          ? 'bg-v-300 border-transparent !text-n-0'
          : 'border-transparent dark:bg-n-600'
      ]"
      @click="() => clickTab(option.id)"
    >
      <span class="leading-none">{{ option.label }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

export type Option = {
  id: string
  label: string
}

type Props = {
  options: Option[]
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false
})

const model = defineModel<string>()

const optionsRef = ref<HTMLElement[]>([])

watch(model, () => {
  if (!model.value) return
  const tabIndex = props.options.findIndex(t => t.id === model.value)
  if (tabIndex < 0) return
  optionsRef.value[tabIndex].scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'center'
  })
})

function clickTab(id: string) {
  model.value = id
}
</script>
